<template>
  <v-dialog v-model="dialog" max-width="400" @click:outside="close">
    <v-card>
      <v-card-title class="headline">Restart Bookie</v-card-title>
      <v-card-text>
        <v-select
          :items="bookieNames"
          v-model="selectedBookie"
          label="Select Bookie"
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click="close">
          Cancel
        </v-btn>

        <v-btn
          color="green darken-1"
          @click="validate"
          :disabled="!selectedBookie"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../lib/constants";

export default {
  name: "RestartBookie",
  data() {
    return {
      selectedBookie: null,
      bookieNames: Object.keys(Constants.BOOKIE_DESCRIPTIONS).sort()
    };
  },
  props: ["bot", "bookies", "dialog", "close", "confirm"],
  computed: {
    bookieDescription(name) {
      return Constants.BOOKIE_DESCRIPTIONS[name];
    }
  },
  methods: {
    validate() {
      this.confirm(this.bot, this.selectedBookie);
    }
  }
};
</script>

<style lang="scss" scoped>
.price {
  float: right;
}

.back-price {
  color: royalblue;
}

.lay-price {
  color: palevioletred;
}
</style>
